// import React, { useEffect, useImperativeHandle, useState, useCallback } from "react"
// import { useAppContext } from "../../API/Context-API/AppContext"
// import Animated, { Easing, runOnJS, useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated"
// import { Pressable } from "native-base"
// import { StyleSheet } from "react-native"

// export interface handleBackDrop {
//   setStart: (x: boolean) => any
// }

// export interface BackDropProps {
//   onPress?: () => any
//   initial?: boolean
// }

// export const BackDrop = React.forwardRef<handleBackDrop, BackDropProps>(
//   ({ initial = false, onPress }, ref) => {
//     const { currentHeight, currentWidth } = useAppContext()

//     const opacity = useSharedValue(0)
//     const animatedStyle = useAnimatedStyle(() => ({ opacity: opacity.value }))

//     const [render, setRender] = useState(initial) // <-- важно: если initial=true, сразу рендерим
//     const [start, setStart] = useState(initial)

//     const setStartSafe = useCallback((x: boolean) => {
//       setStart(x)
//     }, [])

//     useImperativeHandle(ref, () => ({
//       setStart: setStartSafe,
//     }))

//     useEffect(() => {
//       if (start) setRender(true)

//       opacity.value = withTiming(
//         start ? 0.7 : 0,
//         { duration: 300, easing: Easing.ease },
//         (finished) => {
//           if (!finished) return
//           if (!start) runOnJS(setRender)(false)
//         }
//       )
//     }, [start])

//     if (!render) return null

//     return (
//       <Pressable
//         style={[
//           StyleSheet.absoluteFill,
//           { zIndex: 1, height: currentHeight, width: currentWidth },
//         ]}
//         pointerEvents={start ? "box-only" : "box-none"}
//         onPress={onPress}
//       >
//         <Animated.View style={[{ flex: 1, backgroundColor: "rgb(0,0,0)" }, animatedStyle]} />
//       </Pressable>
//     )
//   }
// )

// export default BackDrop




import React, { useEffect, useImperativeHandle, useState, useCallback } from "react";
import { useAppContext } from "../../API/Context-API/AppContext";
import Animated, { Easing, runOnJS, useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import { Pressable } from "native-base";
import { StyleSheet } from "react-native";

export interface handleBackDrop {
  setStart: (x: boolean) => any;
}

export interface BackDropProps {
  onPress?: () => any;
  initial?: boolean;
}

export const BackDrop = React.forwardRef<handleBackDrop, BackDropProps>(
  ({ initial = false, onPress }, ref) => {
    const { currentHeight, currentWidth } = useAppContext();

    const opacity = useSharedValue(0);
    const animatedStyle = useAnimatedStyle(() => ({ opacity: opacity.value }));

    const [render, setRender] = useState(initial);
    const [start, setStart] = useState(initial);

    const setStartSafe = useCallback((x: boolean) => {
      setStart(x);
    }, []);

    useImperativeHandle(ref, () => ({
      setStart: setStartSafe,
    }));

    useEffect(() => {
      if (start) setRender(true);

      opacity.value = withTiming(
        start ? 0.7 : 0,
        { duration: 300, easing: Easing.ease },
        (finished) => {
          if (!finished) return;
          if (!start) runOnJS(setRender)(false);
        }
      );
    }, [start]);

    if (!render) return null;

    return (
      <Pressable
        style={[
          StyleSheet.absoluteFill,
          { zIndex: 1, height: currentHeight, width: currentWidth },
        ]}
        // ✅ железно: когда закрыто — вообще не перехватываем события
        pointerEvents={start ? "auto" : "none"}
        onPress={start ? onPress : undefined}
      >
        <Animated.View style={[{ flex: 1, backgroundColor: "rgb(0,0,0)" }, animatedStyle]} />
      </Pressable>
    );
  }
);

export default BackDrop;
